import { render, staticRenderFns } from "./TDA-G12.vue?vue&type=template&id=0dd9e137&scoped=true"
import script from "./TDA-G12.vue?vue&type=script&lang=js"
export * from "./TDA-G12.vue?vue&type=script&lang=js"
import style0 from "./TDA-G12.vue?vue&type=style&index=0&id=0dd9e137&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd9e137",
  null
  
)

export default component.exports